export const formatedColor = (clr = '') => {
  if (clr.includes(',')) {
    return `rgba(${clr})`;
  } else {
    return `#${clr}`;
  }
};
